import React from "react";
import "./Promotions.css";
import parse from "html-react-parser";
import DownloadSection from "./DownloadSection";

const PromotionSection = ({
  promoKey,
  id,
  header,
  subheader,
  description,
  imageSrc,
  imageAlt,
  additionalInfo,
  qrCode,
  hyperlink,
  steps = [],
  stepsbullet = [],
  campaignDesc,
  campaignPeriod = [],
}) => {
  return (
    <section className="showcase" id={id} style={{ marginTop: "75px" }}>
      <div className="container-fluid p-0">
        <div className="row g-0" style={{ marginTop: "-10.5vh" }}>
          <div
            className={`col-lg-6 order-lg-${(promoKey % 2) + 1} showcase-text`}
          >
            <p
              className="lead mb-0 fontresizesubheader aos-init aos-animate"
              data-aos="fade-up"
              data-aos-delay="200"
              style={{
                fontFamily: "Poppins, sans-serif",
                color: "#7f6c59",
                paddingTop: "13px",
              }}
            >
              <span style={{ fontWeight: "800" }}>{header}</span>
            </p>

            <p
              className="lead mb-0 fontresize aos-init aos-animate"
              data-aos="fade-up"
              data-aos-delay="200"
              style={{
                fontFamily: "Poppins, sans-serif",
                color: "#7f6c59",
                paddingTop: "13px",
              }}
            >
              <span
                style={{ fontWeight: "bold" }}
              >{typeof subheader === "string" ? parse(subheader) : subheader}</span>
            </p>
            <p
              className="lead mb-0 fontresize aos-init aos-animate"
              data-aos="fade-up"
              data-aos-delay="200"
              style={{
                fontFamily: "Poppins, sans-serif",
                color: "rgb(127, 108, 89)",
                paddingTop: "13px",
                fontWeight: 500,
              }}
            >
              <span>{typeof description === "string" ? parse(description) : description}</span>

            </p>
            {/* <ol>
              {steps.map((step, index) => (
                <li
                  key={index}
                  className="lead mb-0 fontresize aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "rgb(127, 108, 89)",
                    paddingTop: "0px",
                    fontWeight: 500,
                  }}
                >
                  s
                </li>
              ))}
            </ol>
            <ul>
              {stepsbullet.map((stepbullet, index) => (
                <li
                  key={index}
                  className="lead mb-0 fontresize aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "rgb(127, 108, 89)",
                    paddingTop: "0px",
                    fontWeight: 500,
                  }}
                >
                  s
                </li>
              ))}
            </ul> */}
            {qrCode && (
              <p
                className="lead mb-0 fontresize aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif",
                  color: "rgb(127, 108, 89)",
                  paddingTop: "13px",
                  textAlign: "center",
                }}
              >
                <p
                  className="lead mb-0 fontresize aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "rgb(127, 108, 89)",
                    paddingTop: "13px",
                    fontWeight: "bold",
                  }}
                 >{typeof qrCode?.title === "string" ? parse(qrCode?.title) : qrCode?.title}</p>
                <p
                  className="lead mb-0 fontresize aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-delay="200"
                  style={{
                    fontFamily: "Poppins, sans-serif",
                    color: "rgb(127, 108, 89)",
                    paddingTop: "13px",
                    fontWeight: 500,
                  }}
                  >{typeof qrCode?.subtitle === "string" ? parse(qrCode?.subtitle) : qrCode?.subtitle}</p>
                <img
                  className="img-fluid"
                  src={qrCode?.qrCodeSrc}
                  width="130vw"
                  alt="QR code for acquisition campaign"
                />
              </p>
            )}
            {hyperlink && (
              <p
                class="lead mb-0 fontresize aos-init aos-animate"
                data-aos="fade-up"
                data-aos-delay="200"
                style={{
                  fontFamily: "Poppins, sans-serif", 
                  color:"#7f6c59",
                  paddingTop: "13px",
                  textAlign:"center",
                  }}
              >
                <a
                  href={hyperlink}
                  class="btn btn-primary btn-lg"
                  role="button"
                  aria-disabled="true"
                  target="_blank"
                >
                  Click Here to Download
                </a>
              </p>
            )}
            <p
              className="lead mb-0 fontresize aos-init aos-animate"
              data-aos="fade-up"
              data-aos-delay="200"
              style={{
                fontFamily: "Poppins, sans-serif",
                color: "rgb(127, 108, 89)",
                paddingTop: "13px",
                fontWeight: 500,
              }}
             >{typeof additionalInfo === "string" ? parse(additionalInfo) : additionalInfo}</p>
          </div>
          <div
            className={`col-lg-6 text-white ${
              (promoKey % 2) + 1 === 1 ? "order-lg-2" : "order-lg-1"
            }
               showcase-img`}
            style={{ background: "#ffffff" }}
          >
            <p style={{ color: "#000" }}>
              <img alt={`Promotion Poster ${promoKey+1}`} className="img-fluid" src={imageSrc} />
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionSection;
